export enum ProjectionRateType {
    custom = 'custom',
    global = 'GlobalRate',
    macro = 'MacroRate',
    stat = 'StatisticalRate'
}
